export enum SupportedChainId {
    OPTIMISM_GOERLI = 420,
}
